import { memoize } from '../../utils';

// browsers cap live WebGL contexts per page, so release the probe's context immediately
function releaseContext(gl: WebGLRenderingContextBase) {
  try {
    gl.getExtension('WEBGL_lose_context')?.loseContext();
  } catch {
    // releasing is best-effort and says nothing about whether WebGL is supported
  }
}

function canCreateContext(create: () => WebGLRenderingContextBase | null): boolean {
  let gl: WebGLRenderingContextBase | null;
  try {
    gl = create();
  } catch {
    return false;
  }
  if (!gl) return false;
  releaseContext(gl);
  return true;
}

function canCreateWebGLContext(): boolean {
  const canvas = document.createElement('canvas');
  return canCreateContext(() => canvas.getContext('webgl2')) || canCreateContext(() => canvas.getContext('webgl'));
}

/**
 * Whether the browser can create a WebGL context, which Zoom needs to render remote screen shares.
 * False when graphics acceleration is turned off, the GPU is blocklisted, or WebGL is disabled by policy.
 * Toggling graphics acceleration only takes effect after a browser relaunch, so the result is cached.
 * Call it before the video SDK allocates WebGL contexts so the per-page context cap cannot skew the result.
 */
export const isWebGLSupported = memoize(canCreateWebGLContext);
